import { createSlice } from "@reduxjs/toolkit";
import {
  transactionYearCreated,
  transactionYearCreating,
  transactionYearCreatingError,
  transactionYearDeleted,
  transactionYearDeleting,
  transactionYearDeletingError,
  transactionYearsLoaded,
  transactionYearsLoading,
  transactionYearsLoadingError,
  resetTransactionYearDeleteState,
  resetTransactionYearCreateState,
} from "./transactionYearStateActions";
import { PURGE } from "redux-persist";
import { ITransactionYearModel } from "../../../types/types";

interface TransactionYearState {
  loading: boolean;
  creating: boolean;
  created: boolean;
  createError: string | null;
  error: string | null;
  years: ITransactionYearModel[];
  yearsLoaded: boolean;
  deleting: boolean;
  deleted: boolean;
  deleteError: string | null;
}

const initialState: TransactionYearState = {
  loading: false,
  creating: false,
  created: false,
  error: null,
  years: [],
  createError: null,
  yearsLoaded: false,
  deleting: false,
  deleted: false,
  deleteError: null,
};

// export const fetchTransactionYears = createAsyncThunk(
//   "transactionYears/fetch",
//   async () => {
//     return await api.getTransactionYears();
//   }
// );

// export const createTransactionYear = createAsyncThunk(
//   "transactionYears/create",
//   async (year: number) => {
//     var response = await api.createTransactionYear(year);
//     return {
//       year: year,
//       transactionCount: 0,
//       id: response,
//     } as TransactionYear;
//   }
// );

const transactionYearSlice = createSlice({
  name: "transactionYears",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
    builder
      .addCase(transactionYearsLoading, (state) => {
        state.loading = true;
        state.error = null;
        state.yearsLoaded = false;
      })
      .addCase(transactionYearsLoaded, (state, action) => {
        state.loading = false;
        state.years = action.payload;
        state.yearsLoaded = true;
        state.error = null;
      })
      .addCase(transactionYearsLoadingError, (state) => {
        state.loading = false;
        state.error = "Failed to fetch transaction years";
      })
      .addCase(transactionYearCreating, (state) => {
        state.creating = true;
        state.created = false;
        state.createError = null;
      })
      .addCase(transactionYearCreated, (state, action) => {
        state.creating = false;
        state.created = true;
        state.years.push(action.payload);
      })
      .addCase(transactionYearCreatingError, (state, action) => {
        state.creating = false;
        state.created = false;
        state.createError =
          action.payload ?? "Failed to create transaction year";
      })
      .addCase(transactionYearDeleting, (state) => {
        state.deleting = true;
        state.deleted = false;
        state.deleteError = null;
      })
      .addCase(transactionYearDeleted, (state, action) => {
        state.deleting = false;
        state.deleted = true;
        state.years = state.years.filter((year) => year.id !== action.payload);
      })
      .addCase(transactionYearDeletingError, (state, action) => {
        state.deleting = false;
        state.deleted = false;
        state.deleteError = action.payload;
      })
      .addCase(resetTransactionYearDeleteState, (state) => {
        state.deleting = false;
        state.deleted = false;
        state.deleteError = null;
      })
      .addCase(resetTransactionYearCreateState, (state) => {
        state.creating = false;
        state.created = false;
        state.createError = null;
      });
  },
});

export default transactionYearSlice.reducer;
